// Attachment download URLs are AUTHENTICATED server-side: append a credential
// (?token=) so <img>/links keep working. Embedded chats use the GPT share
// token (exposed on window.INSIGHT_SHARE_TOKEN by ChatInterfaceEmbedded);
// the authenticated app uses its JWT from localStorage.
export function attachmentUrl(id) {
  if (!id) return null;
  if (id.startsWith('blob:') || id.startsWith('data:')) return id;
  const base = window.INSIGHT_CONFIG?.API_URL ?? '';
  let token = null;
  try {
    token = window.INSIGHT_SHARE_TOKEN || localStorage.getItem('cme_token');
  } catch {
    /* private mode */
  }
  return `${base}/attachments/${id}${token ? `?token=${encodeURIComponent(token)}` : ''}`;
}
